import { cn } from "@/libs/utils";

const SearchIconWebView = ({ className }: { className?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
    >
      <path
        d="M11 19.0024C15.4183 19.0024 19 15.4207 19 11.0024C19 6.58416 15.4183 3.00244 11 3.00244C6.58172 3.00244 3 6.58416 3 11.0024C3 15.4207 6.58172 19.0024 11 19.0024Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 21.0024L16.7 16.7024"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SearchIconWebView;
